import { CellularDeviceSelectorController } from './CellularDeviceSelectorController';

/* Component to render a selector used to associate a module with a cellular device (e.g. Cradlepoint or Netcomm) for analytics purposes */

export class CellularDeviceSelectorComponent implements angular.IComponentOptions {
    public static $name: string = 'cellularDeviceSelector';

    public bindings: any = {
        canEditCellularDevice: '<',
        canRequestActivation: '=',
        canRequestActivationStatus: '<',
        canRequestDeactivation: '=',
        cellularDeviceInfo: '=', /* Two-way binding for now -- can probably be replaced with $doCheck, TODO */
        cellularDeviceStatus: '=',
        jobNumber: '<',
        locationId: '<',
        moduleId: '<',
        mustSaveBeforeActivation: '<?',
        onCellularDeviceStatusChanged: '&'
    };

    public controller: string = CellularDeviceSelectorController.$name;
    public controllerAs: string = CellularDeviceSelectorController.$controllerAs;

    public template: string = require('!!html-loader!./CellularDeviceSelectorView.html');
}
